import { z } from 'zod';
import { FlowProducedType } from '../../../../flowRun/producedType.js';
import { FlowBlockValueTemplateDurationSchema } from '../../../blockValue/templateDuration.js';
import { BaseFlowBlockSchema } from '../../block.js';
import { FlowSubflowV2BlockConfigSchema } from '../../subflow/v2/config.js';
import { FlowBlockType } from '../../type.js';
/**
 * The `subFlow` here is structurally validated only; flow-api replaces it with the variant that
 * also checks the targeted flow has a published version.
 */
export const FlowIteratorV2BlockConfigSchema = z.object({
    /**
     * A list of items to iterate: run the sub-flow for each item
     */
    items: z.string().or(z.array(z.unknown())),
    /**
     * The sub-flow to execute for each entry in the list
     */
    subFlow: FlowSubflowV2BlockConfigSchema,
    /**
     * (Optional) A duration to wait between each item in the list
     */
    iterationStepDuration: FlowBlockValueTemplateDurationSchema().optional(),
});
export const FlowIteratorV2BlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.IteratorV2),
    config: FlowIteratorV2BlockConfigSchema,
    returnType: z.literal(FlowProducedType.Any).default(FlowProducedType.Any),
});
//# sourceMappingURL=config.js.map